var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.388,
    height: 32.346,
    viewBox: "0 0 36.388 32.346",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons-01",
    d: "M45.523,64.14a1.213,1.213,0,0,0,0,2.425h4.03c2.008,4.972,3.983,9.95,5.977,14.935L53.7,85.911A1.212,1.212,0,0,0,54.823,87.6H75.035a1.213,1.213,0,0,0,0-2.425H56.642l1.049-2.5,19.471-1.553a1.25,1.25,0,0,0,1.083-.936l2.429-10.521a1.269,1.269,0,0,0-1.187-1.479H52.815L51.5,64.9a1.243,1.243,0,0,0-1.124-.758Zm8.263,6.469H77.959l-1.882,8.163L57.64,80.237ZM58.865,88.4a4.044,4.044,0,1,0,4.044,4.044A4.044,4.044,0,0,0,58.865,88.4ZM71,88.4a4.044,4.044,0,1,0,4.042,4.043A4.044,4.044,0,0,0,71,88.4ZM58.865,90.832a1.618,1.618,0,1,1-1.617,1.617,1.6,1.6,0,0,1,1.617-1.617Zm12.131,0a1.618,1.618,0,1,1-1.618,1.617A1.6,1.6,0,0,1,71,90.832Z",
    transform: "translate(-44.31 -64.14)",
    fill: "#333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.92a844f0a661aaaf1cde702f5691ce60.svg";
export { ForwardRef as ReactComponent };